export const capitalise = word => {
  return word[0].toUpperCase() + word.slice(1);
};
